import React from "react";
// import CV from "../../assets/cv.pdf";

const CTA = () => {
  return (
    <div className="cta">
      <a
        href="https://spoo.me/summary"
        className="btn"
        target="_blank"
        rel="noopener noreferrer"
      >
        View Resume
      </a>
      <a href="#contact" className="btn btn-primary">
        Let's Talk
      </a>
    </div>
  );
};

export default CTA;
